import { useQuery } from "react-query";
import { CasPurposesApi } from "@jti/rest-api";
const fetchConsentFields = async (consent) => {
    const api = CasPurposesApi.init();
    return api.getPurposesByStep(consent);
};
export const useConsentFields = (consent) => {
    const { data: consentFields = [], error, isLoading, } = useQuery({
        queryKey: ["consentFields", consent],
        queryFn: () => fetchConsentFields(consent),
        staleTime: 5000,
        retry: 1,
        enabled: !!consent,
    });
    return { consentFields, error, isLoading };
};
//# sourceMappingURL=useConsentsFields.js.map